<template>
    <div @click="checkErrors()">
        <h4><span :class="{'check' : rowsValidated[0] === 'validated', 'x' : rowsValidated[0] === 'error'}"></span>Maten</h4>
        <div class="group">
            <div class="row row-5">
                <text-input label="Lengte (cm)" required="required|numeric|min_value:56|max_value:224" :scope="scope"  class="col"></text-input>
                <text-input label="Bovenwijdte (cm)" required="numeric" :scope="scope" class="col"></text-input>
                <text-input label="Taille (cm)" required="numeric" :scope="scope" class="col"></text-input>
                <text-input label="Heup (cm)" required="numeric" :scope="scope" class="col"></text-input>
                <text-input label="Hoofd (cm)" required="numeric" :scope="scope" class="col"></text-input>
            </div>
        </div>
        <h4><span :class="{'check' : rowsValidated[1] === 'validated', 'x' : rowsValidated[1] === 'error'}"></span>Kleding maten</h4>
        <div class="group">
            <div class="row row-4">
                <select-list label="Confectie" :list="confectionGroup" mode="exact" class="col"></select-list>
                <select-list label="Schoen" :list="shoes" mode="exact" class="col"></select-list>
                <select-list label="Jeans" :list="jeansGroup" mode="exact" class="col"></select-list>
                <select-list :label="gender === 'h' ? 'Boord' : 'BH'" :list="chest_groups[gender]" mode="exact" class="col"></select-list>
            </div>
        </div>

        <h4><span :class="{'check' : rowsValidated[2] === 'validated', 'x' : rowsValidated[2] === 'error'}"></span>Uiterlijk</h4>
        <div class="group">
            <div class="row row-4">
                <select-list label="Ogen" required="required" :scope="scope" :list="eyes" mode="trans" class="col"></select-list>
                <select-list label="Haar" required="required" :scope="scope" :list="hair" mode="trans" class="col"></select-list>
                <select-list label="Bril / Lens" :list="eyewears" mode="exact" class="col"></select-list>
                <select-list v-if="age > 10 && gender === 'h'" label="Snor / Baard" :list="facialhair" mode="exact" class="col"></select-list>
            </div>
        </div>
        <h4><span :class="{'check' : rowsValidated[3] === 'validated', 'x' : rowsValidated[3] === 'error'}"></span>Kenmerken</h4>
        <div class="group">
            <div class="row row-3">
                <div class="col">
                    <select-list label="Littekens" :list="scars" mode="exact"></select-list>
                    <text-input v-if="showScarsWhere" label="Littekens_plek" placeholder="Waar?" required="required" :scope="scope"></text-input>
                </div>
                <div class="col">
                    <select-list label="Tatoeages" :list="tattoos" mode="exact"></select-list>
                    <text-input v-if="showTattoosWhere" label="Tatoeages_plek" placeholder="Waar?" required="required" :scope="scope"></text-input>
                </div>
                <div class="col">
                    <select-list label="Piercings" :list="piercings" mode="exact"></select-list>
                    <text-input v-if="showPiercingsWhere" label="Piercings_plek" placeholder="Waar?" required="required" :scope="scope"></text-input>
                </div>
            </div>
            <div class="row row-total">
                <select-input label="Afkomst vader" required="required" :scope="scope" :list="countries" :multiple="true" class="col"></select-input>
                <select-input label="Afkomst moeder" required="required" :scope="scope" :list="countries" :multiple="true" class="col"></select-input>
            </div>
        </div>
        <span class="form-error" :class="{'is-visible': errors.has('event_date')}">{{ errors.first('event_date') }}</span>
    </div>
</template>
<script type='text/babel'>
    import TextInput from './elements/Input.vue'
    import SelectList from './elements/Select.vue'
    import SelectInput from './elements/SelectInput.vue'
    import countries from '../countries'
    import errorCheck from '../errorCheck'

    export default {
        inject: ['$validator'],
        props: ['isValidated','scope'],
        mixins: [countries, errorCheck],
        components: {
            TextInput,
            SelectList,
            SelectInput,
        },

        mounted() {
            this.$on('change', (value) => this.setValue(value));
            this.$validator.localize('en');
        },
        data: () => ({
            rowsRequired: {
                0: ['Lengte'],
                1: [],
                2: ['Ogen', 'Haar'],
                3: ['Afkomst vader', 'Afkomst moeder']
            },
            hair: ['blond', 'l_blond', 'd_blond', 'blond-grijs', 'bruin', 'l_bruin', 'd_bruin', 'bruin-grijs', 'rood', 'rood-blond', 'rood-bruin', 'rood-grijs', 'grijs', 'zwart', 'zwart-grijs'],
            eyes: ['blauw', 'blauw-bruin', 'blauw-grijs', 'blauw-groen', 'bruin', 'bruin-grijs', 'bruin-groen', 'd_bruin', 'grijs', 'grijs-groen', 'groen', 'groen-blauw', 'groen-bruin', 'groen-grijs'],
            eyewears: ['ja', 'nee', 'soms'],
            facialhair: ['ja', 'nee', 'soms'],
            scars: ['ja', 'nee'],
            tattoos: ['ja', 'nee'],
            piercings: ['ja', 'nee'],
            shoes: ['20', '21', '22', '23', '24', '25', '26', '26-27', '27', '27-28', '28', '28-29', '29', '29-30', '30', '30-31', '31', '31-32', '32', '32-33', '33', '33-34', '34', '34-35', '35', '35-36', '36', '36-37', '37', '37-38', '38', '38-39', '39', '39-40', '40', '40-41', '41', '41-42', '42', '42-43', '43', '43-44', '44', '44-45', '45', '45-46', '46', '46-47', '47', '47-48', '48', '49', '50', '51', '52'],
            chest_groups: {
                'h': ['37', '37-38', '38', '38-39', '39', '39-40', '40', '40-41', '41', '41-42', '42', '42-43', '43', '43-44', '44', '44-45', '45', '45-46', '46', '46-47', '47', '47-48', '48', '48-49', '49', '49-50', '50'],
                'd': ['65AA', '65A', '65B', '65C', '65D', '65E', '65F', '65G', '70AA', '70A', '70B', '70C', '70D', '70E', '70F', '70G', '75AA', '75A', '75B', '75C', '75D', '75E', '75F', '75G', '80AA', '80A', '80B', '80C', '80D', '80E', '80F', '80G', '85AA', '85A', '85B', '85C', '85D', '85E', '85F', '85G', '90AA', '90A', '90B', '90C', '90D', '90E', '90F', '90G', '95AA', '95A', '95B', '95C', '95D', '95E', '95F', '95G', '100AA', '100A', '100B', '100C', '100D', '100E', '100F', '100G'],
            },
            jeans_groups: {
                'd': ['23/30', '23/32', '23/34', '23/36', '24/30', '24/32', '24/34', '24/36', '25/30', '25/32', '25/34', '25/36', '26/30', '26/32', '26/34', '26/36', '27/30', '27/32', '27/34', '27/36', '28/30', '28/32', '28/34', '28/36', '29/30', '29/32', '29/34', '29/36', '30/30', '30/32', '30/34', '30/36', '31/30', '31/32', '31/34', '31/36', '32/30', '32/32', '32/34', '32/36', '33/30', '33/32', '33/34', '33/36', '34/30', '34/32', '34/34', '34/36'],
                'h': ['28/30', '28/32', '28/34', '28/36', '29/30', '29/32', '29/34', '29/36', '30/30', '30/32', '30/34', '30/36', '31/30', '31/32', '31/34', '31/36', '32/30', '32/32', '32/34', '32/36', '33/30', '33/32', '33/34', '33/36', '34/30', '34/32', '34/34', '34/36', '36/30', '36/32', '36/34', '36/36', '38/30', '38/32', '38/34', '38/36', '40/30', '40/32', '40/34', '40/36', '42/30', '42/32', '42/34', '42/36', '44/30', '44/32', '44/34', '44/36']
            },
            confectie_groups: {
                'k': ['56', '62', '68', '74', '80', '86', '92', '98', '104', '104-110', '110', '110-116', '116', '116-122', '122', '122-128', '128', '128-134', '134', '134-140', '140', '140-146', '146', '146-152', '152', '152-158', '158', '158-164', '164'],
                'd': ['34', '34-36', '36', '36-38', '38', '38-40', '40', '40-42', '42', '42-44', '44', '44-46', '46', '46-48', '48'],
                'h': ['46', '46-48', '48', '48-50', '50', '50-52', '52', '52-54', '54', '54-56', '56', '56-58', '58', '58-60', '60'],
            },
            showScarsWhere: false,
            showTattoosWhere: false,
            showPiercingsWhere: false,
        }),
        computed: {
            gender() {
                return this.$store.getters.gender()
            },
            age() {
                return this.$store.getters.age()
            },
            confectionIndex() {
                return this.age < 14 ? 'k' : this.gender
            },
            confectionGroup() {
                return this.confectie_groups[this.confectionIndex]
            },
            jeansGroup(){
                return this.jeans_groups[this.gender]
            }
        },
        methods: {
            setValue(value) {
                if (value.label === 'Littekens') {
                    this.showScarsWhere = value.value === 'ja'
                }
                if (value.label === 'Tatoeages') {
                    this.showTattoosWhere = value.value === 'ja'
                }
                if (value.label === 'Piercings') {
                    this.showPiercingsWhere = value.value === 'ja'
                }
            }
        }
    }
</script>
